import { useEffect, useState } from 'react'
import { Column, Show } from '@/components/core'
import { useScrollPosition } from '@/hooks/useScrollPosition.ts'

export default function VideoBox({ videoUrl }: { videoUrl: string }) {
  const [top, setTop] = useState(0)
  const [left, setLeft] = useState(0)
  const [sticky, setSticky] = useState(false)

  const scrollPosition = useScrollPosition()

  useEffect(() => {
    setTimeout(() => {
      const pageYOffset =
        window.pageYOffset || document.documentElement.scrollTop
      const boundingClientRect = window.document
        .getElementById('conversation-section')
        ?.getBoundingClientRect()

      setLeft(boundingClientRect?.right || 0)
      setTop(pageYOffset + (boundingClientRect?.top || 0))
    }, 1000)
  }, [])

  useEffect(() => {
    const position = scrollPosition + 110
    if (position > top && !sticky) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setSticky(true)
    }
    if (position < top && sticky) {
      setSticky(false)
    }
  }, [scrollPosition, sticky, top])

  return (
    <Show when={!!top}>
      <Column
        className="z-30 h-[180px] w-[280px] bg-electric-indigo-900 overflow-hidden rounded-2xl shadow"
        style={{
          top: sticky ? 100 : top,
          left: left + 16,
          position: sticky ? 'fixed' : 'absolute'
        }}
      >
        <video
          src={`${import.meta.env.VITE_RECORD_BASE_URL}/${videoUrl}`}
          controls={true}
          controlsList="nodownload"
          className="h-full w-auto object-cover"
        ></video>
      </Column>
    </Show>
  )
}
